export default "__VITE_ASSET__CB7i_fEO__"